import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="V-Chat App" link="https://v-chat-by-vansh.herokuapp.com/" bg="linear-gradient(to right,#de6161 0%, #2657eb 100%)" mdxType="ProjectCard">
Realtime chat app with websockets using Node.js, Express and Socket.io with Vanilla JS on the frontend with a custom UI.
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/v-chat"
        }}>{`V-Chat`}</a></p>
    </ProjectCard>
    <ProjectCard title="Triber" link="https://triber-bf4d1.web.app/" bg="linear-gradient(to right, #1d73ad 0%, #0f3443  100%)" mdxType="ProjectCard">
  Its a social media web app, features like coments,likes,profile pic,bio,with All operations.
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/Triber"
        }}>{`Triber`}</a></p>
    </ProjectCard>
    <ProjectCard title="Netflix Clone" link="https://netflix-clone-5966a.web.app/" bg="linear-gradient(to right, #1d73ad 0%, #0f3443  100%)" mdxType="ProjectCard">
  This is a Netflix website built with React js and TMDB Api.
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/Netflix-Clone"
        }}>{`Netflix`}</a></p>
    </ProjectCard>
    <ProjectCard title="Google Clone" link="https://clone-7865a.web.app/" bg="linear-gradient(to right, #8A2387 0%, #E94057 100%)" mdxType="ProjectCard">
  This is a Google Search Engine built with React js and Google Api.
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/Google-Clone"
        }}>{`Google Clone`}</a></p>
    </ProjectCard>
    <ProjectCard title="Amazon Clone" link="https://clone-74fb5.web.app/" bg="linear-gradient(to right,#de6161 0%, #2657eb 100%)" mdxType="ProjectCard">
This Is a e-Commerce That I Had Made with ReactJS (MERN Stack) It Works
seamlessly like AMAZON.
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/eCommerce-Website"
        }}>{`eCommerce`}</a></p>
    </ProjectCard>
    <ProjectCard title="Slack Clone" link="https://slack-clone-172b8.firebaseapp.com/" bg="linear-gradient(to right, #1d73ad 0%, #0f3443  100%)" mdxType="ProjectCard">
  A Group Where Everyone Can Chat and Contribute
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/Slack-Clone"
        }}>{`Slack Clone`}</a></p>
    </ProjectCard>
    <ProjectCard title="Spotify Clone" link="https://spotify-app-c3050.web.app/" bg="linear-gradient(to right, #1d73ad 0%, #0f3443  100%)" mdxType="ProjectCard">
  This is a Spotify Web Clone website built with React js and Spotify Api.
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/Spotify-Clone"
        }}>{`Spotify`}</a></p>
    </ProjectCard>
    <ProjectCard title="Image Classifier" link="https://github.com/VanshVarshney/Image-Classifier" bg="linear-gradient(to right, #8A2387 0%, #E94057 100%)" mdxType="ProjectCard">
  Its a Image classification application using a deep learning model on a dataset of
images.
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/Image-Classifier"
        }}>{`Image Classifier`}</a></p>
    </ProjectCard>
    <ProjectCard title="Covid-19 Tracker" link="https://covid19-tracker-bfdce.web.app/" bg="linear-gradient(to right,#de6161 0%, #2657eb 100%)" mdxType="ProjectCard"> 
  A Covid-19 Tracker Made, This Application is Uses React Hooks & Material UI
      <p>{`Github Repo : `}<a parentName="p" {...{
          "href": "https://github.com/VanshVarshney/Covid19-Tracker"
        }}>{`Covid-19 Tracker`}</a></p>
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      